import NamedId from "@/apps/dashboard/catalog/core/domain/model/NamedId";

export class Import {
  constructor(
    public readonly id: string,
    public readonly origin: string,
    public readonly createdAt: string | null = null,
    public readonly destinationAccount: NamedId | null = null,
    public readonly sourceAccount: NamedId | null = null,
    public readonly createdBy: NamedId | null = null,
    public readonly status: string | null = null,
    public readonly content: string | null = null,
    public readonly strategy: string | null = null,
    public readonly queuedAt: string | null = null,
    public readonly startedAt: string | null = null,
    public readonly endedAt: string | null = null,
    public readonly report: Object | null = null
  ) {}

  get sourceName(): string {
    if (this.createdBy) {
      return this.createdBy.name;
    }
    if (this.sourceAccount) {
      return this.sourceAccount.name;
    }
    if (this.origin == "rs") {
      return "Recommerce";
    }
    return "";
  }
}
